import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';

import * as actions from './actions';
import * as constants from './constants';

export interface Profile {
  activeTab: string;
  errors: string[];
}

export const ProfileDefaultState: Profile = {
  activeTab: 'Profile',
  errors: [],
};

export interface State {
  profile: Profile;
}

export type Action = ActionType<typeof actions>;

export default combineReducers<State, Action>({
  profile: (state = ProfileDefaultState, action) => {
    switch (action.type) {
      case constants.PROFILE_SAVE_ATTEMPT_FAILED:
        return { ...state, errors: action.payload.errors };
      case constants.SET_ACTIVE_TAB:
        return { ...state, activeTab: action.payload.tab };

      default:
        return state;
    }
  },
});
